import React from 'react'

import { useTheme } from 'styled-components'

import { Banner } from '@components/Banner'
import { useOnlineStatus } from '@hooks/utils'

export function OfflineBanner() {
  const isOnline = useOnlineStatus()
  const theme = useTheme()
  return (
    <>
      {!isOnline && (
        <Banner backgroundColor={theme.colors.offlineStatus.offlineBackground}>
          You are Offline. Some features may be unavailable.
        </Banner>
      )}
    </>
  )
}
